import React from "react";
import diamondShapes from "../data/diamondShapes.json";

/**
 * Renders a diamond shape as an inline SVG.
 *
 * @param {string} shapeName  - Name or ID of the shape (e.g. "Round Brilliant", "oval")
 * @param {number} size       - Width & height in px (default 40)
 * @param {string} color      - Stroke color (default "currentColor")
 * @param {string} className  - Optional extra class
 */
const DiamondShapeSVG = ({ shapeName, size = 40, color = "currentColor", className = "" }) => {
  const normalized = (shapeName || "").toLowerCase().trim().replace(/\s+/g, "-");
  
  const shape =
    diamondShapes.find((s) => s.id === normalized) ||
    diamondShapes.find((s) => s.name.toLowerCase() === (shapeName || "").toLowerCase().trim()) ||
    diamondShapes.find((s) => s.id.includes(normalized)) ||
    diamondShapes[0];

  return (
    <svg
      viewBox={shape.viewBox}
      width={size}
      height={size}
      className={`diamond-shape-svg ${className}`}
      aria-label={shape.name}
      role="img"
      style={{ display: "block", flexShrink: 0 }}
    >
      <defs>
        <style>{`
          .diamond-outline    { fill: none; stroke: ${color}; stroke-width: 2.2; stroke-linecap: round; stroke-linejoin: round; }
          .diamond-inner      { fill: none; stroke: ${color}; stroke-width: 1.2; stroke-linecap: round; stroke-linejoin: round; opacity: 0.65; }
          .diamond-facet-line { fill: none; stroke: ${color}; stroke-width: 0.8; stroke-linecap: round; stroke-linejoin: round; opacity: 0.40; }
        `}</style>
      </defs>

      {shape.svg.elements.map((el, i) => {
        switch (el.type) {
          case "circle":
            return <circle key={i} cx={el.cx} cy={el.cy} r={el.r} className={el.className} />;
          case "ellipse":
            return <ellipse key={i} cx={el.cx} cy={el.cy} rx={el.rx} ry={el.ry} className={el.className} />;
          case "polygon":
            return <polygon key={i} points={el.points} className={el.className} />;
          case "path":
            return <path key={i} d={el.d} className={el.className} />;
          case "rect":
            return <rect key={i} x={el.x} y={el.y} width={el.width} height={el.height} rx={el.rx} ry={el.ry} className={el.className} />;
          case "line":
            return <line key={i} x1={el.x1} y1={el.y1} x2={el.x2} y2={el.y2} className={el.className} />;
          default:
            return null;
        }
      })}
    </svg>
  );
};

export default DiamondShapeSVG;